const MAX_HISTORY_MESSAGES = 10;
const MAX_HISTORY_CHARS = 2500;
const MAX_LINE_CHARS = 400;

const LOADING_ID = '__loading__';

export function buildHistory(messages) {
  const exclude = (m) => m.id === LOADING_ID;
  const recent = (messages || []).filter((m) => !exclude(m)).slice(-MAX_HISTORY_MESSAGES);
  const lines = [];
  let total = 0;

  for (const m of recent) {
    const role = m.senderId === 'me' ? 'User' : 'Assistant';
    let body = (m.body || '').replace(/\s+/g, ' ').trim();
    if (body.length > MAX_LINE_CHARS) {
      body = `${body.slice(0, MAX_LINE_CHARS)}...`;
    }
    const line = `${role}: ${body}`;
    if (total + line.length + 1 > MAX_HISTORY_CHARS) break;
    lines.push(line);
    total += line.length + 1;
  }

  return lines.join('\n');
}

export const HISTORY_LOADING_ID = LOADING_ID;
